(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["insole-main-collection"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    var link = event.target.closest('.ic-pagination a');
    if (!link || link.target || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    document.documentElement.classList.add('ic-page-changing');
  });

  window.addEventListener('pageshow', function() {
    document.documentElement.classList.remove('ic-page-changing');
  });

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["insole-search-results"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var link = event.target.closest('.ic-pagination a');
    if (!link || link.target || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    document.documentElement.classList.add('ic-page-changing');
  });

  window.addEventListener('pageshow', function() {
    document.documentElement.classList.remove('ic-page-changing');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
